import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { UseMutationResult } from "@tanstack/react-query";

import createRegulatorPortalInstance from "../../../api/RegulatorPortalInstance";
import type { ReportingPack } from "../regulatorMeClient";
import { parseReportingStartedRunId } from "./parseReportingRuns";
import { REGULATOR_REPORTING_RUNS_PATH } from "./reportingPaths";
import { REPORTING_RUNS_LIST_QUERY_KEY } from "./useReportingRuns";

export type StartReportingRunInput = {
  referenceDate: string;
  pack?: ReportingPack;
};

export function startReportingRun(referenceDate: string): Promise<string | null>;
export function startReportingRun(
  input: StartReportingRunInput,
): Promise<string | null>;
export async function startReportingRun(
  input: string | StartReportingRunInput,
): Promise<string | null> {
  const { referenceDate, pack } =
    typeof input === "string" ? { referenceDate: input } : input;
  const response = await createRegulatorPortalInstance().post(
    REGULATOR_REPORTING_RUNS_PATH,
    {
      reference_date: referenceDate,
      ...(pack ? { pack } : {}),
    },
  );
  return parseReportingStartedRunId(response.data);
}

export const useStartReportingRun = (): UseMutationResult<
  string | null,
  Error,
  StartReportingRunInput
> => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["regulator-portal", "reporting-start"],
    mutationFn: startReportingRun,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: REPORTING_RUNS_LIST_QUERY_KEY,
      });
    },
  });
};
